import React from 'react'
import { Grid, Paper, Typography, withWidth } from '@material-ui/core/index'
import { withTheme } from '@material-ui/core/styles/index'
import GetAppIcon from '@material-ui/icons/GetApp'
import { strings } from '../../../localization/strings'
import moment from 'moment'
import {
    getObjectKey,
    orderStateTypes,
    orderTypes,
    shippingMethods,
} from '../../../server/shared'
import MenuTools from './menu'
import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/Info'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import PrintIcon from '@material-ui/icons/Print'
import CancelIcon from '@material-ui/icons/Cancel'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import {
    PackageIcon,
    BoxDispatchIcon,
    BoxPickupIcon,
} from '../../components/icons'
import withStyles from '@material-ui/core/styles/withStyles'
import Checkbox from '@material-ui/core/Checkbox/Checkbox'
import Button from '@material-ui/core/Button/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import AddOrderToGroupDialog from './dialogs/addOrderToGroupDialog'
import ReadyDialog from './dialogs/readyDialog'
import DownloadAllDialog from './dialogs/downloadAllDialog'
import RemoveOrderToGroupDialog from './dialogs/removeOrderToGroupDialog'
import CancelAllDialog from './dialogs/cancelAllDialog'
import Paginator from './paginator'
import ReservationAllDialog from './dialogs/reservationAllDialog'
import DoorSizeSelector from './doorSizeSelector/doorSizeSelector'
import { connect } from 'react-redux'
import { getPlaftormId } from '../../../helpers/dbHelpers'

const TooltipFontSizeMedium = withStyles({
    tooltip: {
        fontSize: '0.8em',
    },
})(Tooltip)

class Component extends React.Component {
    isDispatchToLocker = (order) => {
        return order.orderTypeId === orderTypes.dispatch
    }

    getPlatformOrderNumber(order, iconSize, fontSize) {
        const orderTypeDivStyle = { display: 'flex', alignItems: 'center' }
        const orderTypeIconStyle = {
            fontSize: iconSize ? iconSize : 28,
            marginRight: 5,
            color: 'gray',
        }
        const orderNumberTypographyStyle = {
            fontSize: fontSize ? fontSize : null,
        }

        /* NOTE: span is used to wrap inner compoments and provide a ref forwarding*/
        if (order.orderTypeId === orderTypes.eCommerce) {
            return (
                <div style={orderTypeDivStyle}>
                    <TooltipFontSizeMedium
                        title={strings.orderTypeTooltip.eCommerce}
                    >
                        <span>
                            <ShoppingCartIcon style={orderTypeIconStyle} />
                        </span>
                    </TooltipFontSizeMedium>
                    <Typography style={orderNumberTypographyStyle}>
                        {strings.orderTypesPrefix.eCommerce}
                        {order.platformOrderNumber}
                    </Typography>
                </div>
            )
        }
        if (order.orderTypeId === orderTypes.noPlatform) {
            return (
                <div style={orderTypeDivStyle}>
                    <TooltipFontSizeMedium
                        title={strings.orderTypeTooltip.noPlatform}
                    >
                        <span>
                            <PackageIcon style={orderTypeIconStyle} />
                        </span>
                    </TooltipFontSizeMedium>
                    <Typography style={orderNumberTypographyStyle}>
                        {strings.orderTypesPrefix.noPlatform}
                        {order.platformOrderNumber}
                    </Typography>
                </div>
            )
        }
        if (order.orderTypeId === orderTypes.dispatch) {
            return (
                <div style={orderTypeDivStyle}>
                    <TooltipFontSizeMedium
                        title={strings.orderTypeTooltip.dispatch}
                    >
                        <span>
                            <BoxDispatchIcon style={orderTypeIconStyle} />
                        </span>
                    </TooltipFontSizeMedium>
                    <Typography style={orderNumberTypographyStyle}>
                        {strings.orderTypesPrefix.dispatch}
                        {order.platformOrderNumber}
                    </Typography>
                </div>
            )
        }
        if (order.orderTypeId === orderTypes.reverseLogistic) {
            return (
                <div style={orderTypeDivStyle}>
                    <TooltipFontSizeMedium
                        title={strings.orderTypeTooltip.reverseLogistic}
                    >
                        <span>
                            <BoxPickupIcon style={orderTypeIconStyle} />
                        </span>
                    </TooltipFontSizeMedium>
                    <Typography style={orderNumberTypographyStyle}>
                        {strings.orderTypesPrefix.reverseLogistic}
                        {order.platformOrderNumber}
                    </Typography>
                </div>
            )
        }
        return (
            <div style={orderTypeDivStyle}>
                <TooltipFontSizeMedium
                    title={strings.orderTypeTooltip.eCommerce}
                >
                    <span>
                        <ShoppingCartIcon style={orderTypeIconStyle} />
                    </span>
                </TooltipFontSizeMedium>
                <Typography style={orderNumberTypographyStyle}>
                    {strings.orderTypesPrefix.eCommerce}
                    {order.platformOrderNumber}
                </Typography>
            </div>
        )
    }

    canceledPackageInside(order) {
        if (
            order.orderStateId === orderStateTypes.cancelled &&
            order.isRecoverable
        )
            return ' con Paquete'
        return ''
    }

    getOrderState(order) {
        const ordersGroupedToReadyForCollect =
            this.props.ordersGroupedToReadyForCollect

        if (order.orderTypeId === orderTypes.dispatch) {
            let orderState =
                strings.dispatchOrderState[
                    getObjectKey(orderStateTypes, order.orderStateId)
                ]
            if (orderState) {
                return orderState
            }
        }
        if (
            order.isGroupedToReadyForCollect &&
            ordersGroupedToReadyForCollect.length <
                this.props.appStore.minimumGroupToReadyForCollect
        ) {
            return 'Esperando cantidad mínima de retiros'
        } else if (
            order.isGroupedToReadyForCollect &&
            ordersGroupedToReadyForCollect.length >=
                this.props.appStore.minimumGroupToReadyForCollect
        ) {
            return 'Listo para confirmar retiro'
        }
        return strings.orderState[
            getObjectKey(orderStateTypes, order.orderStateId)
        ]
    }

    renderMenu = () => {
        let selecteds = this.props.items.filter((x) => x.checked)
        let totalCount = this.props.items.length
        let checkedCount = selecteds.length
        let orderIds = selecteds.map((x) => x.id)
        let ordersReadyToPickUp = this.props.ordersReadyToPickUp
        let minimumGroupToReadyForCollect =
            this.props.appStore.minimumGroupToReadyForCollect
        let shopPickupAvailable = this.props.shopPickupAvailable
        //let isExternalHaulerOrder = selecteds.every(x => !!x.haulerId)

        let show = {}
        const isReverseLogistics = selecteds
            .map((x) => x.orderTypeId)
            .every((x) => x === 4)
        const isNotDeliveredReverseLogistics = selecteds
            .map((x) => x.orderStateId)
            .every((x) => x !== 26)

        show.downloadDialog = true
        show.isReservable =
            selecteds.map((x) => x.isReservable).every((x) => x === true) &&
            this.props.showOrderReservable
        show.cancelAll = selecteds
            .map((x) => x.isCancellable)
            .every((x) => x === true)
        show.removeAllDialog =
            shopPickupAvailable &&
            selecteds
                .map((x) => x.isGroupedToReadyForCollect)
                .every((x) => x === true)
        show.addOrderToGroupDialog =
            minimumGroupToReadyForCollect > 1 &&
            selecteds
                .map((x) => x.isGroupedToReadyForCollect)
                .every((x) => x === false) &&
            show.cancelAll &&
            ordersReadyToPickUp <= minimumGroupToReadyForCollect &&
            shopPickupAvailable &&
            !isReverseLogistics
        show.readyDialog =
            (shopPickupAvailable &&
                selecteds
                    .map((x) => x.isGroupedToReadyForCollect)
                    .every((x) => x === false) &&
                show.cancelAll &&
                ordersReadyToPickUp &&
                ordersReadyToPickUp >= minimumGroupToReadyForCollect) ||
            (show.cancelAll && minimumGroupToReadyForCollect <= 1) ||
            (isReverseLogistics && isNotDeliveredReverseLogistics)
        let width =
            this.props.width === 'xs' || this.props.width === 'sm'
                ? 60
                : this.props.width === 'md'
                ? 40
                : 60

        return !this.props.showOrdersMenu ? null : (
            <div className={'ordersMenu'}>
                <Grid
                    container
                    justify="flex-start"
                    wrap="nowrap"
                    alignItems="flex-start"
                    style={{ marginTop: '15px', marginBottom: '15px' }}
                >
                    <Grid item style={{ minWidth: width }}>
                        <FormControlLabel
                            labelPlacement="bottom"
                            control={
                                <Checkbox
                                    checked={this.props.items.every(
                                        (x) => x.checked
                                    )}
                                    onChange={this.props.handleCheckAllOrders}
                                />
                            }
                            label={'(' + checkedCount + '/' + totalCount + ')'}
                            style={{ marginLeft: 5 }}
                        />
                    </Grid>
                    <Grid
                        item
                        container
                        justify="flex-start"
                        alignItems="center"
                        style={{ marginTop: '10px' }}
                    >
                        {checkedCount <= 0 ? (
                            <Grid item>
                                {' '}
                                <Button color="primary" disabled>
                                    {strings.nothingSelected}
                                </Button>
                            </Grid>
                        ) : (
                            <>
                                {!show.downloadDialog ? null : (
                                    <Grid item style={{ marginBottom: '5px' }}>
                                        {' '}
                                        <Button color="primary">
                                            <GetAppIcon />{' '}
                                            <DownloadAllDialog
                                                orderIds={orderIds}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                            />
                                        </Button>
                                    </Grid>
                                )}
                                {!show.downloadDialog ? null : (
                                    <Grid item style={{ marginBottom: '5px' }}>
                                        {' '}
                                        <Button color="primary">
                                            <PrintIcon />{' '}
                                            <DownloadAllDialog
                                                orderIds={orderIds}
                                                print={true}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                            />
                                        </Button>
                                    </Grid>
                                )}
                                {!show.cancelAll ? null : (
                                    <Grid item style={{ marginBottom: '5px' }}>
                                        {' '}
                                        <Button color="primary">
                                            <CancelIcon />{' '}
                                            <CancelAllDialog
                                                orderIds={orderIds}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                                cancel={true}
                                            />
                                        </Button>
                                    </Grid>
                                )}
                                {!show.addOrderToGroupDialog ? null : (
                                    <Grid item style={{ marginBottom: '5px' }}>
                                        {' '}
                                        <Button color="primary">
                                            <DoneAllIcon />{' '}
                                            <AddOrderToGroupDialog
                                                orderIds={orderIds}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                                ordersGroupedToReadyForCollect={
                                                    this.props
                                                        .ordersGroupedToReadyForCollect
                                                }
                                            />
                                        </Button>
                                    </Grid>
                                )}
                                {!show.readyDialog ? null : (
                                    <Grid item style={{ marginBottom: '5px' }}>
                                        {' '}
                                        <Button color="primary">
                                            <DoneAllIcon />{' '}
                                            <ReadyDialog
                                                orderIds={orderIds}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                                ordersGroupedToReadyForCollect={
                                                    this.props
                                                        .ordersGroupedToReadyForCollect
                                                }
                                            />
                                        </Button>
                                    </Grid>
                                )}
                                {!show.removeAllDialog ? null : (
                                    <Grid item style={{ marginBottom: '5px' }}>
                                        {' '}
                                        <Button color="primary">
                                            <RemoveCircleIcon />{' '}
                                            <RemoveOrderToGroupDialog
                                                orderIds={orderIds}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                                ordersGroupedToReadyForCollect={
                                                    this.props
                                                        .ordersGroupedToReadyForCollect
                                                }
                                            />
                                        </Button>
                                    </Grid>
                                )}
                                {!show.isReservable ? null : (
                                    <Grid item style={{ marginBottom: '5px' }}>
                                        {' '}
                                        <Button color="primary">
                                            <DoneAllIcon />{' '}
                                            <ReservationAllDialog
                                                orderId={orderIds}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                            />
                                        </Button>
                                    </Grid>
                                )}
                            </>
                        )}
                    </Grid>
                </Grid>
            </div>
        )
    }

    render() {
        let props = this.props

        if (!props.items.length) {
            return (
                <Paper
                    style={{
                        padding: 10,
                        margin: 10,
                        background: props.theme.palette.primary.main,
                        opacity: 0.5,
                        textAlign: 'center',
                    }}
                >
                    {strings.ordersGridNotFoundData}
                </Paper>
            )
        }
        return (
            <>
                {this.renderMenu()}

                {props.width === 'xs' || props.width === 'sm' ? (
                    <Paper
                        style={{
                            padding: 1,
                            background: props.theme.palette.primary.main,
                        }}
                    >
                        {props.items.map((order) => (
                            <Paper
                                key={order.id}
                                style={{ margin: 10, padding: 10 }}
                            >
                                <Grid container>
                                    {!props.showOrdersMenu ? null : (
                                        <Grid item container xs={2} sm={1}>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    marginLeft: -10,
                                                    textAlign: 'left',
                                                    width: 60,
                                                }}
                                            >
                                                <Checkbox
                                                    color="primary"
                                                    name={order.id.toString()}
                                                    checked={order.checked}
                                                    onChange={
                                                        props.handleCheckOrder
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                                    <Grid item container xs={9} sm={10}>
                                        <i
                                            style={{
                                                marginRight: 0,
                                                fontSize: 20,
                                                fontWeight: 900,
                                            }}
                                        >
                                            {this.getPlatformOrderNumber(
                                                order,
                                                30,
                                                20
                                            )}
                                        </i>
                                        <Grid item xs={12}>
                                            <Typography noWrap>
                                                {strings.ordersGridDateLabel}:{' '}
                                                {moment(
                                                    order.rootInsertionTS
                                                        ? order.rootInsertionTS
                                                        : order.insertionTS,
                                                    'YYYY-MM-DD'
                                                ).format('DD-MM-YYYY')}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            style={{
                                                textAlign: 'center',
                                                fontSize: 20,
                                            }}
                                        >
                                            <Typography noWrap>
                                                {order.email}
                                            </Typography>
                                            {getPlaftormId() === 2 ? (
                                                <Typography
                                                    noWrap
                                                    style={{ fontSize: '80%' }}
                                                >
                                                    {order.warehouseName}
                                                </Typography>
                                            ) : null}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography noWrap>
                                                {
                                                    strings.ordersGridTrackingNumberLabel
                                                }
                                                : {order.rootTrackingNumber
                                                    ? order.rootTrackingNumber
                                                    : order.trackingNumber}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography noWrap>
                                                {
                                                    strings.ordersGridDepositCodeLabel
                                                }
                                                : {order.depositCode}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography noWrap>
                                                {order.mobilePhoneNumber
                                                    ? strings.ordersGridPhoneLabel +
                                                      ':' +
                                                      order.mobilePhoneNumber
                                                    : ''}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography noWrap>
                                                {strings.ordersGridStateLabel}:{' '}
                                                {this.getOrderState(order)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography noWrap>
                                                {!this.isDispatchToLocker(order)
                                                    ? strings.ordersGridCostLabel
                                                    : null}
                                                {!this.isDispatchToLocker(
                                                    order
                                                ) && strings.costDisclaimer ? (
                                                    <TooltipFontSizeMedium
                                                        title={
                                                            strings.costDisclaimer
                                                        }
                                                    >
                                                        <InfoIcon
                                                            style={{
                                                                fontSize: 16,
                                                                marginLeft: 4,
                                                            }}
                                                        />
                                                    </TooltipFontSizeMedium>
                                                ) : null}
                                                {!this.isDispatchToLocker(order)
                                                    ? ':'
                                                    : null}
                                                {!this.isDispatchToLocker(order)
                                                    && (order.rootCost || order.cost !== null)
                                                    ? ' $' + (order.rootCost ? order.rootCost : order.cost)
                                                    : ''
                                                 }
                                            </Typography>
                                        </Grid>

                                        {!order.insuredValue ? null : (
                                            <>
                                                <Typography noWrap>
                                                    {
                                                        strings.ordersGridPrimeOfInsuredValueLabel
                                                    }
                                                    : +$
                                                    {order.primeOfInsuredValue}
                                                </Typography>
                                                <Typography
                                                    noWrap
                                                    style={{ opacity: 0.5 }}
                                                >
                                                    {
                                                        strings.ordersGridItemsTotalAmountLabel
                                                    }
                                                    : ${order.itemsTotalAmount}
                                                </Typography>
                                                <Typography
                                                    noWrap
                                                    style={{ opacity: 0.5 }}
                                                >
                                                    {
                                                        strings.ordersGridInsuredValueLabel
                                                    }
                                                    : ${order.insuredValue}
                                                </Typography>
                                            </>
                                        )}

                                        <Grid
                                            item
                                            xs={12}
                                            style={{ display: 'flex' }}
                                        >
                                            <Typography noWrap>
                                                {strings.ordersShippingMethodLabel +
                                                    ':    '}
                                                {
                                                    strings.shippingMethods[
                                                        getObjectKey(
                                                            shippingMethods,
                                                            order.shippingMethodId
                                                        )
                                                    ]
                                                }
                                            </Typography>
                                            <div style={{ marginLeft: 8 }} />
                                            <DoorSizeSelector
                                                order={order}
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                    {!props.showOrdersMenu ? null : (
                                        <Grid item container xs={1} sm={1}>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ textAlign: 'right' }}
                                            >
                                                <MenuTools
                                                    orderId={order.id}
                                                    orderData={order}
                                                    isDispatchToLocker={this.isDispatchToLocker(
                                                        order
                                                    )}
                                                    shopPickupAvailable={
                                                        this.props
                                                            .shopPickupAvailable
                                                    }
                                                    actionDone={
                                                        this.props.actionDone
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </Paper>
                        ))}
                    </Paper>
                ) : (
                    <table>
                        <thead>
                            <tr>
                                {!props.showOrdersMenu ? null : <th></th>}
                                <th>
                                    <Typography>
                                        {strings.ordersGridOrderNumberLabel}
                                    </Typography>
                                </th>
                                <th>
                                    <Typography>
                                        {strings.ordersGridEmailLabel}
                                    </Typography>
                                </th>
                                <th>
                                    <Typography>
                                        {strings.ordersGridDepositCodeLabel}
                                    </Typography>
                                </th>
                                <th>
                                    <Typography>
                                        {strings.ordersGridDateLabel}
                                    </Typography>
                                </th>
                                <th>
                                    <Typography>
                                        {strings.ordersShippingMethodLabel}
                                    </Typography>
                                </th>
                                <th>
                                    <Typography>
                                        {strings.ordersGridStateLabel}
                                    </Typography>
                                </th>
                                <th>
                                    <Typography>
                                        {strings.ordersGridCostLabel}
                                        {strings.costDisclaimer ? (
                                            <TooltipFontSizeMedium
                                                title={strings.costDisclaimer}
                                            >
                                                <InfoIcon
                                                    style={{
                                                        fontSize: 16,
                                                        marginLeft: 4,
                                                    }}
                                                />
                                            </TooltipFontSizeMedium>
                                        ) : null}
                                    </Typography>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.items.map((order) => (
                                <tr key={order.id}>
                                    {!props.showOrdersMenu ? null : (
                                        <td>
                                            <Checkbox
                                                color="primary"
                                                name={order.id.toString()}
                                                checked={order.checked}
                                                onChange={
                                                    props.handleCheckOrder
                                                }
                                            />
                                        </td>
                                    )}
                                    <td style={{ paddingTop: 4 }}>
                                        {this.getPlatformOrderNumber(order)}
                                        <div style={{ marginTop: -10 }}>
                                            {strings.ordersGridTrackingNumberLabel +
                                                ':'}{' '}
                                            {order.rootTrackingNumber
                                                ? order.rootTrackingNumber
                                                : order.trackingNumber
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div className="noWrap">
                                            {order.email}
                                        </div>
                                        <div className={'noWrap'}>
                                            {order.mobilePhoneNumber
                                                ? ' \r' +
                                                  strings.ordersGridPhoneShortLabel +
                                                  ': ' +
                                                  order.mobilePhoneNumber
                                                : ''}
                                        </div>
                                        {getPlaftormId() === 2 ? (
                                            <div
                                                className="noWrap"
                                                style={{ fontSize: '80%' }}
                                            >
                                                {order.warehouseName}
                                            </div>
                                        ) : null}
                                    </td>
                                    <td>{order.depositCode}</td>
                                    <td>
                                        {moment(
                                            order.rootInsertionTS
                                                ? order.rootInsertionTS
                                                : order.insertionTS,
                                            'YYYY-MM-DD'
                                        ).format('DD-MM-YYYY')}
                                    </td>
                                    <td>
                                        {
                                            strings.shippingMethods[
                                                getObjectKey(
                                                    shippingMethods,
                                                    order.shippingMethodId
                                                )
                                            ]
                                        }
                                        <DoorSizeSelector
                                            order={order}
                                            actionDone={this.props.actionDone}
                                        />
                                    </td>
                                    <td>
                                        <div className={'noWrap'}>
                                            {this.getOrderState(order) +
                                                this.canceledPackageInside(
                                                    order
                                                )}
                                        </div>
                                        <div
                                            className={'noWrap'}
                                            style={{
                                                fontSize: '.8rem',
                                                color: 'grey',
                                            }}
                                        >
                                            {order.failureCause
                                                ? `Rechazado: ${order.failureCause}`
                                                : null}
                                        </div>
                                    </td>

                                    <td>
                                        {!this.isDispatchToLocker(order)
                                            && (order.rootCost || order.cost !== null)
                                            ? ' $' + (order.rootCost ? order.rootCost : order.cost)
                                            : ''
                                        }
                                        {!order.insuredValue ? null : (
                                            <>
                                                <br />
                                                <TooltipFontSizeMedium
                                                    title={
                                                        <>
                                                            {
                                                                strings.ordersGridItemsTotalAmountLabel
                                                            }
                                                            : $
                                                            {
                                                                order.itemsTotalAmount
                                                            }
                                                            <br />
                                                            {
                                                                strings.ordersGridInsuredValueLabel
                                                            }
                                                            : $
                                                            {order.insuredValue}
                                                            <br />
                                                            {
                                                                strings.ordersGridPrimeOfInsuredValueLabel
                                                            }
                                                            : $+
                                                            {
                                                                order.primeOfInsuredValue
                                                            }
                                                        </>
                                                    }
                                                >
                                                    <Typography
                                                        variant="caption"
                                                        color={'primary'}
                                                    >
                                                        {
                                                            strings.ordersGridprimeOfInsuredValue
                                                        }
                                                        : +$
                                                        {
                                                            order.primeOfInsuredValue
                                                        }
                                                    </Typography>
                                                </TooltipFontSizeMedium>
                                            </>
                                        )}
                                    </td>
                                    {!props.showOrdersMenu ? null : (
                                        <td>
                                            <MenuTools
                                                orderId={order.id}
                                                orderData={order}
                                                orders={this.props.items}
                                                isDispatchToLocker={this.isDispatchToLocker(
                                                    order
                                                )}
                                                shopPickupAvailable={
                                                    this.props
                                                        .shopPickupAvailable
                                                }
                                                actionDone={
                                                    this.props.actionDone
                                                }
                                                ordersGroupedToReadyForCollect={
                                                    this.props
                                                        .ordersGroupedToReadyForCollect
                                                }
                                                ordersReadyToPickUp={
                                                    this.props
                                                        .ordersReadyToPickUp
                                                }
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                <Paginator
                    pageButtons={5}
                    rowLabel={strings.paginatorRowLabel}
                    recordCountLabel={strings.paginatorCount}
                    rowsPerPageOptions={[10, 25, 50]}
                    rowCount={this.props.rowCount}
                    pageIndex={this.props.pageIndex}
                    onChangePage={this.props.onChangePage}
                    rowsPerPage={this.props.rowsPerPage}
                    onChangeRowsPerPage={this.props.onChangeRowsPerPage}
                    style={{ marginTop: 10 }}
                />
            </>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        appStore: store.app,
    }
}

export default connect(mapStateToProps)(withWidth()(withTheme(Component)))
